import { render, staticRenderFns } from "./UploadStatus.vue?vue&type=template&id=485eb50a&scoped=true&"
import script from "./UploadStatus.vue?vue&type=script&lang=js&"
export * from "./UploadStatus.vue?vue&type=script&lang=js&"
import style0 from "./UploadStatus.vue?vue&type=style&index=0&id=485eb50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485eb50a",
  null
  
)

export default component.exports